import { createRouter, createWebHashHistory } from 'vue-router'
import { requireAuth, isLoggedIn } from '@/utils/auth'
import { APP_CONFIG } from '@/config'

const homeComponent =
  APP_CONFIG.BUSINESS_TYPE === 'corporate_website'
    ? () => import('@/pages/corporate')
    : () => import('@/pages/index')

const routes = [
  {
    path: '/',
    name: '首页',
    component: homeComponent,
  },
  {
    path: '/login',
    name: '登录注册',
    component: () => import('@/pages/login'),
  },
  {
    path: '/my',
    name: '我的',
    component: () => import('@/pages/my'),
  },
  {
    path: '/orders',
    name: '我的订单',
    component: () => import('@/pages/orders'),
  },
  {
    path: '/payment',
    name: '支付',
    component: () => import('@/pages/payment'),
  },
  {
    path: '/wallet',
    name: '商户钱包',
    component: () => import('@/pages/wallet'),
  },
  {
    path: '/corporate',
    name: '企业官网',
    component: () => import('@/pages/corporate'),
  },
  {
    path: '/order',
    name: '服务下单',
    component: () => import('@/pages/order'),
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  if (requireAuth(to.path) && !isLoggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath },
    })
  } else {
    next()
  }
})

export default router
